/**
 * Shades slider — centred, enlarged active tile, seamless infinite loop.
 *
 * Swiper's own `loop` + `centeredSlides` is unreliable (it runs out of cloned
 * slides on one side after a few advances and leaves a gap). Instead we build
 * the loop ourselves: repeat the real slides N times in the DOM and run Swiper
 * with loop:false, then on every change teleport the active index back into the
 * middle copy (a no-animation jump between identical copies, so it's invisible).
 * With whole real copies on both sides there are always enough slides to fill
 * the viewport — it can never gap.
 */
(function () {
  var COPIES = 5; // total copies of the slide set; active is kept in the middle

  function revealFallback() {
    document.querySelectorAll('.fibers-shades__swiper').forEach(function (el) {
      if (!el.classList.contains('swiper-initialized')) {
        el.classList.add('fibers-shades--fallback');
      }
    });
  }

  function initOne(el) {
    if (el.dataset.swiperReady) return;
    var wrapper = el.querySelector('.swiper-wrapper');
    if (!wrapper) return;
    var originals = Array.prototype.slice.call(wrapper.children);
    var n = originals.length;
    if (n === 0) return;
    el.dataset.swiperReady = '1';

    // Loop only makes sense with a few slides; below that, show them centred.
    var doLoop = n >= 3;
    var mid = 0;

    if (doLoop) {
      for (var c = 1; c < COPIES; c++) {
        originals.forEach(function (s) {
          var clone = s.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          wrapper.appendChild(clone);
        });
      }
      mid = Math.floor(COPIES / 2) * n; // start of the middle copy
    }

    var swiper = new window.Swiper(el, {
      slidesPerView: 2,
      centeredSlides: true,
      spaceBetween: 0,
      loop: false,
      initialSlide: mid,
      grabCursor: true,
      slideToClickedSlide: true,
      speed: 500,
      watchSlidesProgress: true,
      breakpoints: {
        750: { slidesPerView: 5 },
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      keyboard: { enabled: true },
      a11y: { enabled: true },
    });

    if (doLoop) {
      var lo = mid; // keep the active index within [lo, lo + n)
      swiper.on('slideChange', function () {
        var i = swiper.activeIndex;
        // Map i back into the middle copy — same shade, so the jump is invisible.
        var target = lo + (((i - lo) % n) + n) % n;
        if (target !== i) swiper.slideTo(target, 0, false);
      });
    }
  }

  var waited = 0;
  function initAll() {
    var sliders = document.querySelectorAll('.fibers-shades__swiper');
    if (!sliders.length) return;

    if (typeof window.Swiper === 'undefined') {
      if (waited >= 3000) {
        revealFallback();
        return;
      }
      waited += 50;
      window.setTimeout(initAll, 50);
      return;
    }

    sliders.forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
